
<template>

  <div class="element-signature" id="signature">

    <div  v-if="models.contract_signature && ( $route.query.t == 'contract' && models.contract_signature.contract_signature_contractor_write_name && models.contract_signature.contract_signature_contractor_write_name != ' ' )">
      <center style="padding:100px 0px; font-size:3em;">완료된 자필 페이지 입니다.<br/>감사합니다.</center>
    </div>
    <div  v-else-if="models.contract_signature && ( $route.query.t != 'contract' && models.contract_signature.contract_signature_insured_write_name && models.contract_signature.contract_signature_insured_write_name != ' ' )">
      <center style="padding:100px 0px; font-size:3em;">완료된 자필 페이지 입니다.<br/>감사합니다.</center>
    </div>
    <div class="container" v-else>

      <div class="section" id="section-header" style="padding: 0;">
        <div class="container">
          <p style="text-align: left;">안녕하세요. 정확한 비교견적 설계를 위해 보험사에서 아래의 동의서가 필요합니다.</p><br/>
          <p style="text-align: left;">동의서는 자동차보험 경력 확인용으로만 활용되므로 안심하고 서명패드에 서명해주세요.</p>
          <div id="container">
            <a @click="goSign" style="    display: block;font-size: 20px;font-weight: 600;text-align: center;padding: 10px;width: 150px;background: #174be6;color: white;border-radius: 15px;margin: 20px auto;">자필서명하기</a>
          </div>
        </div>
      </div>



      <div class="section">
        <div class="container">
          <div class="image">
            <img src="/static/sign-1.png" />
          </div>
        </div>
      </div>


      <div style="max-width:800px; margin:0 auto;">
        <div style="padding:10px; padding-bottom:0px;">
          <div style="float:left;border:1px solid #0b2573; padding:10px 20px; cursor:pointer;" :class="{ 'current' : current_pdf == item }"
          v-for="( item, index ) in lists.upload_list_contract" v-if="codes.display_file_tags.indexOf( item.resource_tag ) >= 0" @click="current_pdf=item">{{item.resource_tag}}</div>
        </div>
        <div style="padding:10px; clear:both; padding-top:0px;">


          <a :href="'https://docs.google.com/gview?url=' +current_pdf.resource_url+ '&embedded=true&a=v&pid=explorer&chrome=false&api=true'" v-if="current_pdf && current_pdf.extension == 'pdf'" target="_blank">
            <iframe :src="'https://docs.google.com/gview?url=' +current_pdf.resource_url+ '&embedded=true&a=v&pid=explorer&chrome=false&api=true'" style="width:100%; height:500px;"
            frameborder="0"
            ></iframe>
          </a>
        </div>
      </div>

      <div style="clear:both;"></div>
      <div class="section" id="section-body">
        <div class="container">


          <div class="section-signature">

            <!--<div style="float:left; width:50%;">
              <div class="signature-title"> 자필 패드 </div>
              <VueSignaturePad width="200px" height="100px" ref="handwrite_name" style="background:#efefef;margin:0 auto;"/>

              <center>
                <a type="button" @click="$refs.handwrite_name.undoSignature()" style="text-decoration:underline;">되돌리기</a>
              </center>
            </div>-->

            <div style="margin: auto;">
              <div class="signature-title"> 서명 패드 </div>
              <VueSignaturePad width="200px" height="100px" ref="handwrite_signature" style="background:#efefef;margin:0 auto;"/>

              <center>
                <a type="button" @click="$refs.handwrite_signature.undoSignature()" style="text-decoration:underline;">되돌리기</a>
              </center>
            </div>

            <div style="clear:both;"></div>


            <div style="margin-top:50px;">

              <button id="signTarget" style="line-height: inherit; background: #0b2573;color: #fff; display: block; padding: 10px 0px; margin:0 auto; margin-bottom: 50px; width:100%;" @click="onsubmit()">자필서명 저장하기</button>

            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<style lang="scss">


html, body{ width:100%; overflow-x: hidden;}
/*.navigation-home img{ height:40px !important; width: auto;}*/
.signature-title{ text-align: center; width:200px !important; }
/*.current{ background: #0b2573; color: #fff;border:1px solid #0b2573; cursor:pointer;}*/
.section{
  .image{
    img{ width: 100% }
    width: 100%;
    padding: 5px;
    margin-top: 30px;
    margin-bottom: 10px;
    border: 1px solid $color-gray-dark;
  }
}
</style>
<script>

import jsPDF from 'jspdf';
import SignaturePad from 'signature_pad';
import VueSignaturePad from 'vue-signature-pad';
import Vue from "vue";

export default {
  props: ['id'],
  components: { VueSignaturePad },
  data(){
    return {
      codes : {

        display_file_tags : [ '보험청약서', '보험상품설명서', '신용정보조회및활용동의서','중복가입동의서','마일리지동의서','가입설계동의서' ]
      },
      numPages: undefined,
      current_pdf : null,
      models : {
        admin : null,
        contract: null,
        contract_signature : null,
      },
      signaturePad: '',
      lists: {
        upload_list_contract : []
      }
    }
  },
  created() {

    this.init();
    this.set_signature( this.id );



  },
  mounted() {

  },
  methods: {
    cs(ob){
    },
    /*
    axios.post('https://asia-northeast1-qprice-db76b.cloudfunctions.net/hangout', {
        "rp": data.adminEmail, // 상담자 에게 보내기
        "mg" : " [고객명] "  + data.customerName +  " [접수자] " + _this.$refs.selectAdmin_reporter.adminNames[ _this.$refs.selectAdmin_reporter.value ] + "[접수내용] " + _this.$data.formData.activity_memo_reporter + ' [링크] ' + link
    }).then( res => { } )
    .catch( response => { console.log(response) } );
    */
    set_signature( signature_id )
    {
      /*
      Vue.axios.get(`https://dev-api.insunetfc.com/v1/crm/contract.signature/${signature_id}`).then(res => {
        let { data, error } = res.data;

        data.extra = JSON.parse(data.contract_signature_extra)
        this.$data.models.contract_signature = data;

        this.set_contract( data.contract_id );
        // alert(1);

      })
      .catch(e => {
        //this.$message({ message: e.message, type: 'error' })
      })

      */
    },
    set_contract( contrat_id )
    {
      Vue.axios.get(`https://dev-api.insunetfc.com/v1/crm/contract/${contrat_id}`).then(res => {
        let { data, error } = res.data;

        data.extra = JSON.parse(data.contract_extra)
        this.$data.models.contract = data;
        this.load_list();
      })
      .catch(e => {
        //this.$message({ message: e.message, type: 'error' })
      })
    },
    init(){

      // console.log(  );
      // setInterval( function(){ window.dispatchEvent(new Event('resize')); }, 1000);
      this._data.mode = this.id ? 'edit' : 'create'

      if( this._data.mode == "edit" ){
        Vue.axios.get('https://dev-api.insunetfc.com/v1/crm/contract.signature/'+this.id).then(res => {
          let { data, error } = res.data;
          this.$data.formData = data;

        });
      }else{
        //this.formData.contract_id = this.$props.contractId

      }
    },

    onsubmit()
    {
      var _params = {};
      /* 2020-02-04 자필패드 주석 */

      if( this.$refs.handwrite_signature.isEmpty() ) // || this.$refs.handwrite_name.isEmpty()
      {
        alert( '서명을 적어주셔야 합니다.' );
        return false;
      }

      // 계약자 서명
      if( this.$route.query.t == 'contract' ) {
        //_params.contract_signature_contractor_write_name       = this.$refs.handwrite_name.saveSignature().data
        _params.contract_signature_contractor_write_signature  = this.$refs.handwrite_signature.saveSignature().data
      }else{
        //_params.contract_signature_insured_write_name       = this.$refs.handwrite_name.saveSignature().data
        _params.contract_signature_insured_write_signature  = this.$refs.handwrite_signature.saveSignature().data

      }

      this.$emit( 'saveSign', _params );

      /* 서명 완료시 다음 페이지 이동 */
      this.$parent.$parent.submitProcessor()

      /*
        Vue.axios.put(`https://dev-api.insunetfc.com/v1/crm/contract.signature/edit/${this.$props.id}`, _params).then(res => {
          let { data, error } = res.data;

          // data.extra = JSON.parse(data.contract_extra)
          this.$data.models.contract_signature = data;
          alert( '서명이 완료되었습니다.' );
          location.href="https://insunetfc.com"

        })
        .catch(e => {
          //this.$message({ message: e.message, type: 'error' })
        })
      */
    },

    goSign(){
      this.$smoothScroll({
        scrollTo: document.querySelector('#signTarget'),
        duration: 1000,
        offset: 100,
        updateHistory: false,
        //hash: '#nav-section',
        container: document.querySelector('.element-modal') ? document.querySelector('.element-modal') : document.querySelector('body')
      })
    },
    
    load_list(){
      var _params = { "key": this.$data.models.contract.resource_key, "page": 1, "size": 100 }
      Vue.axios.get("https://dev-api.insunetfc.com/v1/www/resources", {params:_params}).then(res => {

        let { data, error } = res.data;
        if (error) { return;  }
        this.$data.lists.upload_list_contract = data.items;

        this.current_pdf =  data.items[0]

      })
    },
  }
}
</script>
